export default {
    listagem: {
        titulo_pagina: 'Lista de Exámenes',
        novo: 'Crear nuevo examen',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró ningún examen',
            codigo: 'Código',
            nome: 'Nombre',
            mnemonico: 'Mnemotécnico',
            componente: 'Componente',
            metodo: 'Método',
            escala: 'Escala',
            material: 'Material',
            tempo: 'Tiempo',
            editar: 'Editar'
        },
        bulk: {
            inserir: 'Insertar Bulk',
            desselecionar: '¡No se puede fabricar con los elementos seleccionados!',
            selecione_um_item: '¡Seleccione al menos 1 elemento de la lista!',
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Examen',
            editar: 'Editar Examen'
        },
        fieldsets: {
            informacoes: 'Información',
            composicao: 'Composición',
            metodo: 'Método',
            materiais_possiveis: 'Materiales Posibles',
            mnemonicos: 'Mnemotécnica Veus',
            sub_exames: 'Sub Exámenes',
            sinonimos: 'Sinónimos',
            loinc: 'LOINC',
            bypass: 'Derivación de x a',
            compound: 'Examen Compuesto'
        },
        fields: {
            adicionar_subexames: 'Agregar Subexámenes',
            adicionar_sinonimos: 'Agregar Sinónimos',
            adicionar_metodo: 'Agregar Método',
            status: {
                label: 'Estado',
                description: 'Examen estado activo o inactivo'
            },
            ordem_resultado: {
                label: 'Orden / Resultado',
                description: 'Tipo de examen'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del examen'
            },
            codigo: {
                label: 'Código',
                description: 'Código del examen'
            },
            componente: {
                label: 'Componente',
                description: 'Componente del examen'
            },
            material: {
                label: 'Material',
                description: 'Material del examen'
            },
            metodo: {
                label: 'Método',
                description: 'Método del examen',
                warning: {
                    duplicated: 'El método seleccionado ya ha sido agregado!'
                }
            },
            possible_specimens: {
                label: 'Materiales Posibles',
                integration_label: 'Integración de apoyo',
                integration_unavailable: 'Integración no disponible',
                material_label: 'Material posible',
                material_placeholder: 'Ingrese el material posible',
                adicionar: 'Agregar material posible',
                warning: {
                    incomplete: 'Complete la integración de apoyo y el material posible en todas las líneas.',
                    duplicated: 'Esta integración de apoyo ya fue agregada. Solo puede existir un material posible por examen para cada integración de apoyo.'
                }
            },
            tempo: {
                label: 'Tiempo',
                description: 'Tiempo del examen'
            },
            escala: {
                label: 'Escala',
                description: 'Escala del examen'
            },
            mnemonico_veus_exam: {
                label: 'Mnemotécnica Veus Examen',
                description: 'Mnemotécnica Examen'
            },
            mnemonico_veus_subexam: {
                label: 'Mnemotécnica Veus Sub Examen',
                description: 'Mnemotécnica Sub Examen'
            },
            adicionar_sub_exame_form: {
                label: 'Agregar Subexamen'
            },
            adicionar_sinonimos_form: {
                label: 'Agregar Sinónimos'
            },
            specimen_complement: {
                label: 'Material Complementario',
                description: 'Habilitar o deshabilitar la derivación de material complementario'
            },
            directions: {
                ordem: 'Orden',
                resultado: 'Resultado',
                ambos: 'Ambos'
            },
            compound: {
                label: 'Examen Compuesto',
                description: 'Informar si el examen padre en la jerarquía es un examen compuesto'
            },
            botao_salvar : 'Guardar Examen'
        },
        create: {
            success: '¡Examen creado con éxito!',
            error: '¡Error al crear el examen!'
        },
        update: {
            success: '¡Examen editado con éxito!',
            error: '¡Error al editar el examen!'
        }
    }
}
